<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-5" lang="en-GB">R<a id="_idTextAnchor006"></a>espectively Ours</h1>
<p class="Verse-first" lang="en-GB">We sing, we dance, we play</p>
<p class="Verse-main" lang="en-GB">But how long until we have to weigh</p>
<p class="Verse-main" lang="en-GB">Our talents. And wonder how far they will get us.</p>
<p class="Verse-main" lang="en-GB">In a world of competition</p>
<p class="Verse-main" lang="en-GB">We are left only to petition</p>
<p class="Verse-main" lang="en-GB">For our futures, painted in the silver lines of fate.</p>
<p class="Verse-main" lang="en-GB">But wait.</p>
<p class="Verse-new" lang="en-GB">They have left us a world broken,</p>
<p class="Verse-main" lang="en-GB">With a thousand words unspoken.</p>
<p class="Verse-main" lang="en-GB">Stuck with our ever expanding ambition</p>
<p class="Verse-main" lang="en-GB">We are left wishing</p>
<p class="Verse-main" lang="en-GB">For a version of our future,</p>
<p class="Verse-main" lang="en-GB">Where we are not left to pick up</p>
<p class="Verse-main" lang="en-GB">The pieces left by the world’s past abuser.</p>
<p class="Verse-main" lang="en-GB">Where stress and sea levels are rising.</p>
<p class="Verse-main" lang="en-GB">But the polar ice caps are melting.</p>
<p class="Verse-main" lang="en-GB">And we are left waiting.</p>
<p class="Verse-main" lang="en-GB">So the future stays vacant.</p>
<p class="Verse-main" lang="en-GB">But how long until our chances run out?</p>
<p class="Verse-new" lang="en-GB">Until we break this long lasting cycle</p>
<p class="Verse-main" lang="en-GB">And nurse the world back into survival</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781035801855_EPUB-9.vue?7b6a0463